<template>
    
    <div class="w-full 
                h-24 
                flex 
                relative
                bg-gray-100 
                rounded-lg"
    >

        <!-- Previous Date -->

        <div class="w-40 
                    h-full 
                    bg-gray-300 
                    hover:bg-gray-400 
                    rounded-lg 
                    rounded-r-none 
                    flex 
                    items-center 
                    cursor-pointer" 

        @click="goPrev"
        
        >

            <img class="px-4" src="/images/icons/left-nav-arrow-black.svg" alt="left nav arrow" >

            <div class="flex flex-col" >

                <p class="font-bold tracking-widest" >{{ formatDate( prevDate, 'MMM dd' ) }}</p>

                <p class="text-xs text-gray-600 tracking-widest" >{{ formatDistance(prevDate).toUpperCase() }}</p>

            </div>

        </div>

        <!-- Current Date -->

        <div class="flex-grow flex flex-col items-center justify-center relative" >

            <p class="font-bold tracking-widest" >{{ formatDate( currDate, 'MMM. dd yyyy' ) }}</p>

            <p class="text-xs text-gray-500 tracking-widest" >{{ formatDistance(currDate).toUpperCase() }}</p>

            <!-- Calendar Button -->

            <div 
            
            class="calendar-button" 

            @click.stop="toggleCalendar"

            >

                <p class="text-xs text-center font-medium tracking-widest flex-grow" >CALENDAR</p>

                <div class="w-6 
                            h-6 
                            object-scale-down 
                            bg-ch-blue 
                            flex 
                            justify-center" 
                >

                    <img 
                    
                    alt="calendar"
                    draggable="false" 
                    src="/images/icons/arrow-white-small.svg" 
                    class="transform transition-transform duration-300" 

                    :class="{ 'rotate-180': !openCalendar }"
                    
                    >

                </div>

            </div>

            <!-- Calendar dropdown -->

            <div 
            
            class="calendar-dropdown" 
            
            :class="{ 'calendar-dropdown-open': openCalendar }" 

            v-out="closeCalendar"
            
            >



            </div>

        </div>

        <!-- Next Date -->

        <div class="w-40 
                    h-full 
                    bg-gray-300 
                    hover:bg-gray-400 
                    rounded-lg 
                    rounded-l-none 
                    flex items-center 
                    justify-end 
                    cursor-pointer" 

        @click="goNext"
        
        >

            <div class="flex flex-col text-right" >

                <p class="font-bold tracking-widest" >{{ formatDate( nextDate, 'MMM dd' ) }}</p>

                <p class="text-xs text-gray-600 tracking-widest" >{{ formatDistance(nextDate).toUpperCase() }}</p>

            </div>

            <img class="px-4" src="/images/icons/right-nav-arrow-black.svg" alt="left nav arrow" >

        </div>

    </div>

</template>

<script>

    import { useStore } from 'vuex'
    import { format, formatDistanceToNow } from 'date-fns'
    import { ref, computed, onMounted } from 'vue'

    import { out } from '../assets/scripts/clickOutside'
    import { verticalScrollTo } from '../assets/scripts/scrollTo'

    export default {
    
        name: 'Calendar',

        setup( props, { emit } ) {

            const store = useStore()
            const openCalendar = ref(false)
            const appBody = computed(() => store.state.properties.appBody )
            const appScrollTop = computed(() => store.state.properties.appScrollTop )

            const currDate = computed(() => store.state.appointments.curr )
            const prevDate = computed(() => store.state.appointments.prev )
            const nextDate = computed(() => store.state.appointments.next )

            const formatDate = ( date, template ) => {

                return format( new Date( date ), template ) 

            }

            const formatDistance = ( date ) => {

                return formatDistanceToNow( new Date(date), { addSuffix: true } )

            }

            const toggleCalendar = () => {

                const scrollTop = appScrollTop.value
                const elOffset = document.getElementById('appointments').offsetTop
                const distance = elOffset - scrollTop

                openCalendar.value ? false : verticalScrollTo( appBody.value, distance, 500 )
                openCalendar.value = !openCalendar.value

            }

            const closeCalendar = () => {

                openCalendar.value = false

            }

            const goPrev = async () => {

                store.commit('setAppointments', [])

                emit( 'direction', 'previous' )

                const appointments = await store.dispatch( 'getAppointments', prevDate.value.split('T')[0] )

            }

            const goNext = async () => {

                store.commit('setAppointments', [])

                emit( 'direction', 'future' )

                const appointments = await store.dispatch( 'getAppointments', nextDate.value.split('T')[0] )

            }

            return {
                goPrev,
                goNext,
                currDate,
                prevDate,
                nextDate,
                formatDate,
                formatDistance,
                closeCalendar,
                openCalendar,
                toggleCalendar
            }

        },

        directives: { out }

    }

</script>

<style scoped>

    .calendar-button {
        @apply
            w-32 
            h-6 
            bg-yellow-500 
            absolute 
            left-1/2 
            transform 
            -translate-x-1/2 
            top-80
            z-20
            flex 
            rounded-sm 
            items-center 
            justify-center 
            overflow-hidden 
            select-none 
            cursor-pointer
    }

    .calendar-dropdown {
        background-image: url("/images/loader.svg");
        @apply
            w-full 
            h-0
            bg-ch-gray-blue 
            z-10 
            absolute 
            top-100 
            rounded-cs-md 
            shadow-xl
            transition-height
            bg-no-repeat
            bg-center
    }

    .calendar-dropdown-open {
        @apply
            h-96
            duration-300
    }

</style>